// Patients keep a device record for every replacement they were ever sent, so the
// same device type can appear several times. Keep only the most recently assigned
// record per device type. If the API sends no date we cannot tell which record is
// the latest, so the list is returned untouched rather than guessing.
const DATE_FIELDS = ["assignedAt", "createdAt", "updatedAt"];

const getAssignedDate = (row) => {
  const field = DATE_FIELDS.find((f) => row && row[f]);
  return field ? new Date(row[field]).getTime() : 0;
};

const getLatestDevices = (devices) => {
  console.log("getLatestDevices-----------------", devices);
  if (!Array.isArray(devices) || devices.length === 0) return devices;
  if (!devices.some((row) => getAssignedDate(row))) return devices;

  const latestByType = new Map();
  devices.forEach((row) => {
    const type = row && row.device && row.device._id;
    if (!type) return;
    const current = latestByType.get(type);
    if (!current || getAssignedDate(row) > getAssignedDate(current)) {
      latestByType.set(type, row);
    }
  });

  return devices.filter((row) => {
    const type = row && row.device && row.device._id;
    return !type || latestByType.get(type) === row;
  });
};

export default getLatestDevices;
